"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToNearest = roundToNearest;
/**
 *
 * @param round The number to round to the nearest of. e.g. 0.1 to nearest tenth or 0.5 for nearest half
 * @param numToRound
 * @returns
 */
function roundToNearest(round, numToRound) {
    const reciprocal = 1 / round;
    return Math.round(numToRound * reciprocal) / reciprocal;
}
